export enum AppMainMenu {
  offBillIncentiveList = 'Off Bill Incentive List',
  agreementList = 'Agreement List',
  newIncentive = 'New Incentive',
}
